import * as React from "react";
import { useNavigate } from "react-router-dom";
import { useTitle } from "../../utils/UseTitleUtils";
import { GAEvents } from "utils/GoogleAnalytics";
import CommonIcons from "utils/CommonIcons";
import MarketingHero from "components/marketing/MarketingHero";

interface EmailVerifiedProps {}

const EmailVerified = (props: EmailVerifiedProps) => {
  const navigate = useNavigate();
  useTitle("Email Confirmed!");
  const eventTracker = new GAEvents();

  React.useEffect(() => {
    eventTracker.userConversion();

    const redirectHandle = setTimeout(() => {
      navigate("/auth/login", {
        replace: true,
      });
    }, 5000);

    return () => clearTimeout(redirectHandle);
  }, []);

  return (
    <div className="marketing-page marketing-page--status">
      <main className="marketing-page__main">
        <MarketingHero title="Email Confirmed!" />

        <section className="marketing-page__section">
          <div className="marketing-page__status-card">
            <div className="marketing-page__status-icon marketing-page__status-icon--success">
              <CommonIcons.EmailConfirmed />
            </div>
            <h1 className="marketing-page__status-title">Email Confirmed!</h1>
            <div className="marketing-page__status-copy">
              <p>Your email has been successfully confirmed.</p>
              <p>You will automatically be redirected to the login page.</p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default EmailVerified;
